import {
  REQUEST_EMPLOYEE_MASTER,
  REQUEST_EMPLOYEE_MASTER_FAILURE,
  REQUEST_EMPLOYEE_MASTER_SUCCESS,
  REQUEST_EMPLOYEE_DETAIL_ORG,
  REQUEST_EMPLOYEE_DETAIL_ORG_FAILURE,
  REQUEST_EMPLOYEE_DETAIL_ORG_SUCCESS,
  PATCH_EMPLOYEE_DETAIL_IDENTIFICATION_REQUEST,
  PATCH_EMPLOYEE_DETAIL_IDENTIFICATION_SUCCESS,
  PATCH_EMPLOYEE_DETAIL_IDENTIFICATION_FAILURE,
} from '../constants/ActionTypes';

export default function profileReducer(state = {}, action) {
  switch (action.type) {
    case REQUEST_EMPLOYEE_MASTER:
      return {
        ...state,
        ...action,
      };
    case REQUEST_EMPLOYEE_MASTER_FAILURE:
      return {
        ...state,
        ...action,
      };
    case REQUEST_EMPLOYEE_MASTER_SUCCESS:
      return {
        ...state,
        ...action,
      };
    case REQUEST_EMPLOYEE_DETAIL_ORG:
      return {
        ...state,
        ...action,
      };
    case REQUEST_EMPLOYEE_DETAIL_ORG_FAILURE:
      return {
        ...state,
        ...action,
      };
    case REQUEST_EMPLOYEE_DETAIL_ORG_SUCCESS:
      return {
        ...state,
        ...action,
      };
    case PATCH_EMPLOYEE_DETAIL_IDENTIFICATION_REQUEST:
      return {
        ...state,
        ...action,
      };
    case PATCH_EMPLOYEE_DETAIL_IDENTIFICATION_SUCCESS:
      return {
        ...state,
        ...action,
      };
    case PATCH_EMPLOYEE_DETAIL_IDENTIFICATION_FAILURE:
      return {
        ...state,
        ...action,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/profileReducer.js